import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useSetRecoilState } from "recoil";
import styled from "styled-components";
import { useApi } from "../../../../hooks/useApi";
import Blank from "../../../DefaultStyles/Blank";
import Loader from "../../../DefaultStyles/Loader";
import { Textarea } from "../../../Input/Textarea";
import AlertModal from "../../../Modal/AlertModal";
import DefaultModalLayout, {
  defaultModalType,
} from "../../../Modal/DefaultModalLayout";
import { ModalRow } from "../../Users/UserDetail/BlackListModal/BlackListModal";
import TargetContainer, {
  ModalLabel,
} from "../../Users/UserDetail/CommentModal/TargetContainer";
import {
  GetServiceSetData,
  GetSubscriptionSetData,
} from "../../../../ApiTS/ServiceDatasTS";
import {
  getSubscriptionNameV3,
  GetSubscriptionSetData_V3,
} from "../../../../ApiTS/ServiceDatasTS_V3";
import DropDown, { OptionType } from "../../../Filters/DropDown";
import { GetPromotionSetData } from "../../../../ApiTS/ApiPromotionTS";

interface CouponRegisterModalProps {
  closeEvent: () => void;
  confirmEvent: () => void;
  userData?: {
    uid: string;
    name: string;
    nickname: string;
  };
}

export default function CouponUseModal({
  closeEvent,
  confirmEvent,
  userData,
}: CouponRegisterModalProps) {
  const [memo, setMemo] = useState("");
  const [targetUid, setTargetUid] = useState(
    userData ? `${userData?.uid}_${userData?.name}_${userData?.nickname}` : ""
  );

  const [confirmBtnClick, setConfirmBtnClick] = useState(false);
  const [alertModal, setAlertModal] = useState(false);

  const [inputPointValue, setInputPointValue] = useState("");
  interface Coupon {
    id: string;
    servId: number;
    promid: number;
    // add other properties if needed
  }

  const [CouponList, setCouponList] = useState<Coupon[]>([]);
  interface Party {
    servsubsid: number;
    partyId: string;
    grade: number;
    // add other properties if needed
  }

  const [PartyList, setPartyList] = useState<Party[]>([]);

  const [SelectedParty, setSelectedParty] = useState<OptionType>({
    value: "",
    label: "선택",
  });

  const [SelectedCoupon, setSelectedCoupon] = useState<OptionType>({
    value: "",
    label: "선택",
  });

  const { response, error, loading } = useApi({
    method: "get",
    url: `coupon?use=0&uid=${userData?.uid}&page=0&size=20`,
  });

  const {
    response: partyListResponse,
    error: partyListError,
    loading: partyListLoading,
  } = useApi({
    method: "get",
    url: `user/${userData?.uid}/party?state=1&page=0&size=20`,
  });

  const {
    response: couponUseResponse,
    error: couponUseError,
    loading: couponUseLoading,
  } = useApi({
    method: "post",
    url: confirmBtnClick ? `coupon/couponuse` : undefined,
    data: {
      uid: Number(userData?.uid),
      partyid: Number(SelectedParty.value),
      couponid: Number(SelectedCoupon.value),
    },
  });

  const getCouponListByServId = () => {
    const subsId = PartyList.find(
      (d) => d.partyId === SelectedParty.value!
    )?.servsubsid;
    const grade = PartyList.find(
      (d) => d.partyId === SelectedParty.value!
    )?.grade;
    const servId = GetSubscriptionSetData_V3(subsId!)?.SVC_ID;
    const list = CouponList.filter(
      (coupon) =>
        (coupon.servId === 0 || coupon.servId === servId) &&
        (GetPromotionSetData(coupon?.promid)?.PROM_USER === grade ||
          GetPromotionSetData(coupon?.promid)?.PROM_USER === 2)
    );
    // debugger;
    return list.map((d) => ({
      value: d.id.toString(),
      label: GetPromotionSetData(d?.promid)?.PROM_NM,
    }));
  };

  useEffect(() => {
    setSelectedCoupon({ value: "", label: "선택" });
  }, [SelectedParty]);

  //   쿠폰 리스트 받아오기
  useEffect(() => {
    if (response?.status === 200 || response?.status === 201) {
      setCouponList(response?.data?.items);
    }
  }, [closeEvent, confirmEvent, response]);

  //   파티 리스트 받아오기
  useEffect(() => {
    if (
      partyListResponse?.status === 200 ||
      partyListResponse?.status === 201
    ) {
      setPartyList(partyListResponse?.data?.items);
      //   toast.success("파티 리스트 받아오기 완료.");
    }
  }, [partyListResponse]);

  //   쿠폰 사용하기
  useEffect(() => {
    if (
      couponUseResponse?.status === 200 ||
      couponUseResponse?.status === 201
    ) {
      closeEvent();
      toast.success("쿠폰 사용하기 완료");
    }
  }, [couponUseResponse]);

  useEffect(() => {
    if (error || partyListError || couponUseError) {
      const errorData =
        error?.data ?? partyListError?.data ?? couponUseError?.data;
      toast.error(errorData);
      setConfirmBtnClick(false);
    }
  }, [error, partyListError, couponUseError]);

  const getCouponInfo = (servId: number) => {
    const servData = GetServiceSetData(servId);
    return servData?.SVC_NMKR_TEMP;
  };

  const getPartyInfo = (subsId: number) => {
    return getSubscriptionNameV3(subsId);
  };

  console.log(SelectedCoupon?.value, SelectedParty?.value);

  return (
    <DefaultModalLayout
      closeEvent={() => closeEvent()}
      modalTitle={"쿠폰 사용"}
      confirmEvent={
        () => setConfirmBtnClick(true) // api 실행
      }
      confirmDisabled={
        memo === "" || SelectedParty.value === "" || SelectedCoupon.value === ""
      }
    >
      {/* 대상 */}
      <>
        <ModalRow>
          <TargetContainer targetUid={targetUid} setTargetUid={setTargetUid} />
        </ModalRow>
      </>

      <>
        {/* {CouponList.map((coupon) => (
          <ModalLabel>{getCouponInfo(coupon?.servId)}</ModalLabel>
        ))} */}

        {/* {PartyList.map((party) => (
          <ModalRow>
            <ValueContainer>
              {party?.partyId + " " + getPartyInfo(party?.servsubsid)}
            </ValueContainer>
            
          </ModalRow>
        ))} */}
      </>

      <ModalLabel>{"파티 선택"}</ModalLabel>
      <DropDown
        dropdownValue={SelectedParty}
        setDropDownValue={setSelectedParty}
        optionList={PartyList.map((party) => ({
          value: party.partyId.toString(),
          label: `${party.partyId} ${getPartyInfo(party.servsubsid)}`,
        }))}
        boxWidth={140}
      />

      <ModalLabel>{"쿠폰 선택"}</ModalLabel>
      <DropDown
        dropdownValue={SelectedCoupon}
        setDropDownValue={setSelectedCoupon}
        // optionList={CouponList.map((coupon) => ({
        //   value: coupon.servId.toString(),
        //   label: coupon.servId.toString(),
        // }))}
        optionList={getCouponListByServId()}
        boxWidth={140}
      />
      {/* 내용 */}
      <ModalLabel>{"내용"}</ModalLabel>
      <Blank blankHeight={0} marginHeight={16} />

      <Textarea
        placeholder={"내용 입력 (필수)"}
        onChange={(e) => setMemo(e.target.value)}
        value={memo}
      />

      <Blank blankHeight={40} marginHeight={40} />

      <>
        {(loading || partyListLoading || couponUseLoading) && <Loader />}

        {/* 포인트 임의 차감 체크 모달 */}
        {alertModal && (
          <AlertModal
            title={`${targetUid}님의
      ${inputPointValue} 포인트를 차감합니다.
      계속 하시겠습니까?`}
            confirmEvent={() => {
              setAlertModal(false);
              setConfirmBtnClick(true);
            }}
            cancelEvent={() => setAlertModal(false)}
          />
        )}
      </>
    </DefaultModalLayout>
  );
}

export const ValueContainer = styled.div`
  width: calc(100% - 106px);
  display: flex;
  align-items: center;
  gap: 10px;
`;
